import { TPointCustomField } from '@project/view-models';
import { formatCurrency } from 'src/app/core/helpers/format-currency';
import { decodeBase64Text } from 'src/app/project/components/input/rich-text/decode-base64-text';
import { generatePlainText } from 'src/app/project/components/input/rich-text/generate-plain-text';
import { translate } from 'src/app/project/features/translate/translate';
import { transformTimeCF } from 'src/app/project/modules/custom-fields/custom-field-time/custom-field-time-transformer';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import { GET_PREFERENCES } from 'src/app/project/modules/preferences/preferences.store';
import { transformDate } from 'src/app/project/shared/date-transformer';
import { TCustomField } from '../../../custom-fields/custom-fields.model';
import { GET_CUSTOM_FIELDS } from '../../../custom-fields/custom-fields.store';
import { TPreferences } from '../../../preferences/preferences.model';
import { getEmptyGroupName } from './empty-group-name';

export function transformCustomFieldValue(
  customFieldId: string,
  pointCustomField?: TPointCustomField | null,
): string {
  const emptyGroupValue = getEmptyGroupName();
  let value = '';
  const preferences = GET_PREFERENCES();
  const customField = GET_CUSTOM_FIELDS()[customFieldId];

  switch (customField.type) {
    case ECustomFieldType.RICHTEXT:
      value = generatePlainText(decodeBase64Text(pointCustomField?.value));
      break;
    case ECustomFieldType.CHECKBOX:
      value =
        pointCustomField?.value === 'true' || pointCustomField?.value === true
          ? translate('yes')
          : translate('no');
      break;
    case ECustomFieldType.DATE:
      value = transformDate({
        value: pointCustomField?.value,
        localTime: false,
        format: preferences.dateFormat,
      });
      break;
    case ECustomFieldType.TIME:
      value = transformTimeCF(
        pointCustomField?.value ? pointCustomField?.value : '',
        customField.showHoursOnly,
      );
      break;
    case ECustomFieldType.COST:
      value = transformCostCF(customField, pointCustomField);
      break;
    case ECustomFieldType.NUMBERS:
      value = transformNumbersCF(customField, pointCustomField);
      break;
    case ECustomFieldType.PERCENTAGE:
      value = pointCustomField?.value ? pointCustomField?.value + '%' : '';
      break;
    case ECustomFieldType.FORMULA: {
      switch (customField.outputType) {
        case ECustomFieldType.NUMBERS:
          value = transformNumbersCF(customField, pointCustomField);
          break;
        case ECustomFieldType.COST:
          value = transformCostCF(customField, pointCustomField);
          break;
        case ECustomFieldType.PERCENTAGE:
          value = pointCustomField?.value ? pointCustomField?.value + '%' : '';
          break;
        default:
          value = '';
          break;
      }
      break;
    }
    case ECustomFieldType.TIMELINE:
      value = transformTimelineCF(pointCustomField, emptyGroupValue, preferences);
      break;
    default:
      value = pointCustomField?.value;
      break;
  }

  return value || emptyGroupValue;
}
function transformTimelineCF(
  pointCustomField: TPointCustomField,
  emptyGroupValue: string,
  preferences: TPreferences,
) {
  const timelineValue = pointCustomField?.value;

  if (timelineValue) {
    const dates = timelineValue.split('~');

    return (
      transformDate({
        value: dates[0],
        inputHourFormat: '',
        format: preferences.dateFormat,
        localTime: false,
      }) +
      ' - ' +
      transformDate({
        value: dates[1],
        inputHourFormat: '',
        format: preferences.dateFormat,
        localTime: false,
      })
    );
  }

  return emptyGroupValue;
}

function transformNumbersCF(customField: TCustomField, pointCustomField: TPointCustomField) {
  if (!pointCustomField?.value) {
    return '';
  }

  const unit = customField.unit ? customField.unit : '';
  const numbersValue = pointCustomField?.value ? pointCustomField?.value : '';

  return numbersValue + unit;
}

function transformCostCF(customField: TCustomField, pointCustomField: TPointCustomField) {
  const costCurrencySymbol = customField.currencySymbol;
  const costValue = parseFloat(pointCustomField?.value);

  if (costValue) {
    return formatCurrency(costValue, costCurrencySymbol, +customField.decimalPlaces);
  }

  return '';
}
